import { render, staticRenderFns } from "./ToDispatch.vue?vue&type=template&id=308531d2"
import script from "./ToDispatch.vue?vue&type=script&lang=js"
export * from "./ToDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports